module.exports = __webpack_public_path__ + "img/progressCheck.ae7e8f08.svg";